import React from 'react';
import { useDaresFilter } from 'root/src/client/web/record/DropEvent/DaresFilter/DaresFilterProvider';
import { ArrowDropDownSharp } from '@mui/icons-material';
import { getReadableDarePlatform } from 'root/src/shared/platforms/helpers/getReadablePlatform';
import { DarePlatformIcon, DarePlatformIconTooltip } from 'root/src/client/web/base/CustomButton/PlatformIcon';
import { Checkbox } from 'root/src/client/v2/form/components/Checkbox';
import * as Accordion from '@radix-ui/react-accordion';
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem';
import { DROPS_ANALYTIC_EVENTS } from 'root/src/shared/drops/drops.analytics';
export const PlatformFilter = React.memo(() => {
    const { state, options, onFilterChange } = useDaresFilter();
    const handleValueChange = (option) => {
        analyticsSendItem(DROPS_ANALYTIC_EVENTS.DROP_DARE_FILTERS, 'channel');
        if (state.platforms.includes(option)) {
            onFilterChange(Object.assign(Object.assign({}, state), { platforms: state.platforms.filter(item => item !== option) }));
        }
        else {
            onFilterChange(Object.assign(Object.assign({}, state), { platforms: [...state.platforms, option] }));
        }
    };
    return (<Accordion.Root className="AccordionRoot" type="single" collapsible defaultValue="platform">
			<Accordion.Item className="AccordionItem overflow-x-hidden" value="platform">
				<Accordion.AccordionTrigger className="uppercase flex py-2 justify-between group w-full">
					<span className="flex w-full">
						Platform
					</span>
					<ArrowDropDownSharp className="!transition !duration-200 -rotate-90 group-data-[state=open]:rotate-0"/>
				</Accordion.AccordionTrigger>
				<Accordion.AccordionContent className="AccordionContent">
					<ul className="flex flex-col gap-3 p-4">
						{options.platforms.map((option) => {
            const isSelected = state.platforms.includes(option.value);
            return (<li key={option.value} className="flex flex-initial font-medium font-mono justify-between items-center gap-4">
									<label htmlFor={`platform-${option.value}`} className="flex w-full gap-3 items-center select-none">
										<DarePlatformIconTooltip variant="light" platform={option.value}>
											<DarePlatformIcon className="size-6" platform={option.value}/>
										</DarePlatformIconTooltip>
										<span>{getReadableDarePlatform(option.value)}</span>
									</label>
									<Checkbox id={`platform-${option.value}`} onCheckedChange={() => handleValueChange(option.value)} checked={isSelected}/>
								</li>);
        })}
					</ul>
				</Accordion.AccordionContent>
			</Accordion.Item>
		</Accordion.Root>);
});
